// Announcement

//function initCookies() {
//    var cookieName = "cookieNotice";
//    var $cookieNotice = document.getElementById("cookieNotice");

//    document.getElementById('cookieClose').click(function () {
//        alert("clicked");
//        var date2 = new Date();
//        //console.log(moment(date2).format('YYYY-MM-DD , h:mm:ss a '));
//        $cookieNotice.addClass('hidden');

//        //Need to specify PM
//        Cookies.set(cookieName, { createdDate: moment(date2, 'YYYY-MM-DD ,h:mm:ss A').format('YYYY-MM-DD , h:mm:ss a') }, {
//            expires: 365,
//        });

//    });

//if (Cookies.get(cookieName)) {
//    //console.log('cookies hide');
//    $cookieNotice.addClass('cookie-notice--hide');
//} else {
//    //console.log('cookies show');
//    $cookieNotice.removeClass('cookie-notice--hide');
//}

//};

//function deferCookies(method) {
//    if (window.jQuery) {
//        //console.log('All loaded and ready for cookie notice cookies');
//        method();
//    }
//    else {
//        setTimeout(function () { deferCookies(method) }, 50);
//    }
//}

//deferCookies(function () {
//    initCookies();
//});
function initCookies() {
    var cookieName = "cookieNotice";
    var $cookieNotice = document.getElementById("cookieNotice");
    var cookieClose = document.getElementById("cookieClose");
    let cookies = document.cookie;
    //console.log("Test");

    if (cookies.match(/^(.*;)?\s*cookieNotice\s*=\s*[^;]+(.*)?$/)) {
        //console.log('cookies hide');
        $cookieNotice.classList.add('hidden');
    } else {
        //console.log('cookies show');
        $cookieNotice.classList.remove('hidden');
    }
    cookieClose.addEventListener('click', function (e) {
        var date2 = new Date();
        var expireDate = new Date();
        expireDate.setFullYear(expireDate.getFullYear() + 3);
        //console.log(moment(date2).format('YYYY-MM-DD , h:mm:ss a '));
        $cookieNotice.classList.add('hidden');
        document.cookie = "cookieNotice=Accepted;expires=" + expireDate;
    });
}